module.exports = __webpack_public_path__ + "c_static/img/2-3电脑天猫收藏夹.fc45c09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/收藏购物车/2-3电脑天猫收藏夹.jpg
// module id = TPeU
// module chunks = 33